import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '../assets/images/icon-cross.svg'


const _hoisted_1 = { class: "px-5 py-4 flex items-center justify-between" }
const _hoisted_2 = { class: "flex items-center space-x-3" }
const _hoisted_3 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  width: "11",
  height: "9"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  fill: "none",
  stroke: "#FFF",
  "stroke-width": "2",
  d: "M1 4.304L3.696 7l6-6"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  class: "w-3",
  src: _imports_0,
  alt: "",
  srcset: ""
}, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "text-sm font-medium text-gray-900" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_notification = _resolveComponent("notification")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.markItem(_ctx.todo.index))),
          class: _normalizeClass([
          _ctx.todo.completed
            ? 'bg-pink-300 bg-gradient-to-tl from-purple-900'
            : 'bg-white border-gray-300 dark:border-gray-600 border dark:bg-transparent',
          'relative w-6 h-6 flex items-center justify-center rounded-full',
        ])
        }, [
          (_ctx.todo.completed)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("p", {
          class: _normalizeClass([
          _ctx.todo.completed
            ? 'line-through text-gray-300 dark:text-gray-500'
            : 'text-gray-600',
          'truncate w-64 text-sm dark:text-gray-300 capitalize',
        ])
        }, _toDisplayString(_ctx.todo.title), 3)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteToDo(_ctx.todo.index))),
        class: "focus:outline-none"
      }, _hoisted_7)
    ]),
    _createVNode(_component_notification, {
      show: _ctx.notification,
      onClosenotification: _cache[2] || (_cache[2] = ($event: any) => (_ctx.closenotification($event)))
    }, {
      default: _withCtx(() => [
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.todoNotificationTitle), 1)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}